module.exports = __webpack_public_path__ + "img/杜宾-1.f680a8ec.jpg";